import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { FocusTrapDeprecatedDirective, FocusTrapDirective, FocusTrapFactory } from './focus-trap';
import { HotkeyPressEvent, HotkeysService } from './hotkeys.service';
import { InteractionEventDirective } from './interactions-event.directive';
import { InteractivityChecker } from './interactivity-checker';
import { ScrollTrapDirective } from './scroll-trap';

const DIRECTIVES = [
  ScrollTrapDirective,
  FocusTrapDirective,
  FocusTrapDeprecatedDirective,
  InteractionEventDirective,
];

@NgModule({
  imports: [CommonModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class RtUICoreA11yModule {
  public static forRoot(): ModuleWithProviders<RtUICoreA11yModule> {
    return {
      ngModule: RtUICoreA11yModule,
      providers: [FocusTrapFactory, InteractivityChecker, HotkeysService],
    };
  }
}

export { HotkeyPressEvent, HotkeysService, InteractivityChecker };
export { FocusTrap, FocusTrapFactory } from './focus-trap';
export { isFakeMousedownFromScreenReader } from './fake-mousedown';
export {
  ScrollTrapDirective,
  FocusTrapDirective,
  FocusTrapDeprecatedDirective,
  InteractionEventDirective,
};
